import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import withAuth from '../../../../core/EcrionProvider/boot/withAuth';
import useJob from './useJob';
import DataItem from '../../../../data/Item';
import Utils from '../../../../utils';
import utils from '../data/utils';
import Loader from './Loader';
import Error from './Error';
import CommunicationRun from './CommunicationRun';
import JobDetails from './Job';
import { RunContext, RunContextProvider } from '../context/RunContext';
/**
 * @param {import('../data/types').JobSummary} job
 * @return {boolean}
 * */

var showJobDetails = function showJobDetails(job) {
  if (!job) return false;
  return job.Stage !== 'WaitingForInput' && job.Stage !== 'WaitingForTask' && job.Stage !== 'WaitingForSignature';
};
/**
 * @param {import('./types').RunLoaderProps} props
 */


var ProjectNameLoader = function ProjectNameLoader(props) {
  var projectName = props.projectName,
      rest = _objectWithoutProperties(props, ["projectName"]);

  return React.createElement(DataItem, {
    dataType: "projectName",
    id: projectName
  }, function (_ref) {
    var loading = _ref.loading,
        error = _ref.error,
        value = _ref.value;
    if (loading) return React.createElement(Loader, null);
    if (error) return React.createElement(Error, null, "Cannot load project '", projectName, "': ", Utils.getPrettyError(error));
    /** @type {import('../data/types').CommunicationProject}*/

    var project = value;
    return React.createElement(JobLoader, Object.assign({
      project: project
    }, rest));
  });
};
/**
 * @param {import('./types').RunLoaderProps} props
 */


var ProjectUIDLoader = function ProjectUIDLoader(props) {
  var projectUid = props.projectUid,
      rest = _objectWithoutProperties(props, ["projectUid"]);

  return React.createElement(DataItem, {
    dataType: "projectUid",
    id: projectUid
  }, function (_ref2) {
    var loading = _ref2.loading,
        error = _ref2.error,
        value = _ref2.value;
    if (loading) return React.createElement(Loader, null);
    if (error) return React.createElement(Error, null, "Cannot load project with id '", projectUid, "': ", Utils.getPrettyError(error));
    /** @type {import('../data/types').CommunicationProject}*/

    var project = value;
    return React.createElement(JobLoader, Object.assign({
      project: project
    }, rest));
  });
};
/**
 * @param {import('./types').RunLoaderProps} props
 */


var ProjectIDLoader = function ProjectIDLoader(props) {
  var projectId = props.projectId,
      rest = _objectWithoutProperties(props, ["projectId"]);

  return React.createElement(DataItem, {
    dataType: "project",
    id: projectId
  }, function (_ref3) {
    var loading = _ref3.loading,
        error = _ref3.error,
        value = _ref3.value;
    if (loading || !value) return React.createElement(Loader, null);
    if (error) return React.createElement(Error, null, "Cannot load project with id '", projectId, "': ", Utils.getPrettyError(error));
    /** @type {import('../data/types').CommunicationProject}*/

    var project = value;
    return React.createElement(JobLoader, Object.assign({
      project: project
    }, rest));
  });
};
/**
 * @param {import('./types').RunLoaderProps & {project: import('../data/types').CommunicationProject}} props
 */


var JobLoader = function JobLoader(props) {
  var jobId = props.jobId,
      allowMissingJobId = props.allowMissingJobId,
      project = props.project,
      rest = _objectWithoutProperties(props, ["jobId", "allowMissingJobId", "project"]);

  var workspace = project.Workspace; // use an async job loader here since it is required a custom logic

  var jobState = useJob(jobId, workspace);
  var loading = jobState.loading,
      error = jobState.error,
      job = jobState.job,
      setJob = jobState.setJob;
  if (loading) return React.createElement(Loader, null);
  if (error && !allowMissingJobId) return React.createElement(Error, null, "Cannot found job with id: ", jobId);
  if (!project.Enabled) return React.createElement(Error, null, "Project '", project.Name, "' is disabled.");

  var onJobCreated = function onJobCreated(jobSummary) {
    if (props.onJobCreated) props.onJobCreated(jobSummary);else setJob(jobSummary);
  };

  var onJobStarted = function onJobStarted(jobSummary) {
    if (props.onJobStarted) props.onJobStarted(jobSummary);else setJob(jobSummary);
  };

  var onJobUpdated = function onJobUpdated(jobSummary) {
    setJob(jobSummary);
  };

  return React.createElement(CommunicationRunning, Object.assign({
    project: project,
    job: job
  }, rest, {
    onJobCreated: onJobCreated,
    onJobStarted: onJobStarted,
    onJobUpdated: onJobUpdated
  }));
};

var CommunicationRunning = function CommunicationRunning(props) {
  var project = props.project,
      job = props.job,
      projectName = props.projectName,
      projectId = props.projectId,
      projectUid = props.projectUid,
      workspace = props.workspace,
      jobId = props.jobId,
      variant = props.variant,
      title = props.title,
      onClose = props.onClose,
      showToolbar = props.showToolbar,
      parameters = props.parameters,
      token = props.token,
      rest = _objectWithoutProperties(props, ["project", "job", "projectName", "projectId", "projectUid", "workspace", "jobId", "variant", "title", "onClose", "showToolbar", "parameters", "token"]);

  if (variant === 'microservice') React.createElement(CommunicationRun, Object.assign({
    project: project,
    job: job,
    jobId: job && job.Id
  }, rest, {
    parameters: parameters
  }));
  var showFormSubmission = utils.getParameterValue(parameters, 'view') === 'submission';
  if (showJobDetails(job) && !showFormSubmission) return React.createElement(JobDetails, {
    job: job,
    project: project,
    workspace: project.Workspace,
    variant: variant,
    onJobUpdated: rest.onJobUpdated,
    toolbar: showToolbar && {
      title: title || job.JobName,
      onClose: onClose
    }
  });
  return React.createElement("div", null, React.createElement(CommunicationRun, Object.assign({
    project: project,
    job: job
  }, rest, {
    toolbar: showToolbar && {
      title: title || job && job.JobName || project.Name,
      onClose: onClose
    },
    showFormSubmission: showFormSubmission,
    enableAdvanced: variant !== 'portal',
    hideFinalizeToolbar: true,
    jobId: job && job.Id,
    parameters: parameters
  })));
};
/**
 * Load a project and/or a job and then render children with those properties
 * @param {import('./types').RunLoaderProps} props
 */


var LoaderWithContext = function LoaderWithContext(props) {
  return React.createElement(RunContextProvider, {
    reducers: [],
    data: {}
  }, props.projectName && React.createElement(ProjectNameLoader, props), props.projectUid && React.createElement(ProjectUIDLoader, props), props.projectId && React.createElement(ProjectIDLoader, props));
};
/**
 * Load a project and/or a job and then render children with those properties
 * @param {import('./types').RunLoaderProps & import('../types').RunAuthProps} props
 */


var RunLoader = function RunLoader(props) {
  var context = React.useContext(RunContext);
  var token = props.token,
      auth = props.auth,
      setAuth = props.setAuth;
  React.useEffect(function () {
    if (token) setAuth({
      token: token
    });
    return function () {
      setAuth({
        token: auth.token
      });
    };
  }, [token]);
  if (token && auth.token !== token) return React.createElement(Loader, null);
  var projectName = props.projectName,
      projectUid = props.projectUid,
      projectId = props.projectId;
  if (!projectName && !projectUid && !projectId) return React.createElement(Error, null, "Unable to load a project because neither projectName nor projectUid are available.");
  if (!context) return React.createElement(LoaderWithContext, props);
  if (projectName) return React.createElement(ProjectNameLoader, props);
  if (projectUid) return React.createElement(ProjectUIDLoader, props);
  return React.createElement(ProjectIDLoader, props);
};
/** @type {import('react').FC<import('./types').RunLoaderProps>} */


var RunLoaderWithAuth = withAuth(RunLoader);
export default RunLoaderWithAuth;